// extracted by mini-css-extract-plugin
export default {"container":"PO-z","darkBackground":"QO-z","whiteBackground":"RO-z","headerButton":"SO-z","calloutHeading":"TO-z","calloutSubHeading":"UO-z"};